import React from "react"
import "twin.macro"
const Footer = () => {
  return (
    <div tw=" grid md:(grid-cols-8 gap-10 pt-6) max-w-7xl">
      {/* left side */}
      <div tw=" md:col-span-2 w-full"></div>
      <div tw="md:col-span-5">
        <p tw="pl-12">Made by tech tomatoes</p>
      </div>
    </div>
  )
}
export default Footer
